// extracted by mini-css-extract-plugin
export default {"onlyDark":"WorkExperience_onlyDark__jnv5K","onlyLight":"WorkExperience_onlyLight__SmDmi","work-experience":"WorkExperience_work-experience__Z+o1n"};